import { Component } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { AppRepository } from '@timechef/core/state';
import { BookingRepository } from '@timechef/features/booking/state/booking.repository';

@Component({
  selector: 'app-store-inspector-modal',
  templateUrl: './store-inspector-modal.component.html',
  styleUrls: ['./store-inspector-modal.component.scss'],
  standalone: false,
})
export class StoreInspectorModalComponent {
  stores: StoreGetter[] = [
    new StoreGetter('App', () => {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const { logs: ommited, ...data } = this.appRepo.getStoreSnapshot();
      // remove logs
      return data;
    }),
    new StoreGetter('Booking', () => this.bookingRepo.getStoreSnapshot()),
  ];

  lastStoreOpened?: StoreGetter;
  constructor(
    private modalCtrl: ModalController,
    private bookingRepo: BookingRepository,
    private appRepo: AppRepository,
  ) {}

  async dismissModal() {
    await this.modalCtrl.dismiss();
  }

  fetchStore(ev: any) {
    if (this.lastStoreOpened) {
      delete this.lastStoreOpened?.date;
    }

    const store = this.stores.find((x) => x.name === ev.detail.value);
    if (store) {
      store?.fetch();
      this.lastStoreOpened = store;
    }
  }
}

export class StoreGetter {
  data: any;
  date?: Date;

  constructor(
    public name: string,
    private getter: () => any,
  ) {}

  fetch() {
    this.data = this.getter();
    this.date = new Date();
  }
}
